import AccountBalance from './icons/AccountBalance';
import AccountCircle from './icons/AccountCircle';
import Add from './icons/Add';
import AddIcCall from './icons/AddIcCall';
import ArrowDownward from './icons/ArrowDownward';
import ArrowDropDown from './icons/ArrowDropDown';
import ArrowForward from './icons/ArrowForward';
import ArrowOutward from './icons/ArrowOutward';
import ArrowUpward from './icons/ArrowUpward';
import Article from './icons/Article';
import AutoGraph from './icons/AutoGraph';
import BarChart from './icons/BarChart';
import CallReceived from './icons/CallReceived';
import Cases from './icons/Cases';
import Check from './icons/Check';
import ChevronLeft from './icons/ChevronLeft';
import ChevronRight from './icons/ChevronRight';
import Circle from './icons/Circle';
import Close from './icons/Close';
import CurrencyBitcoin from './icons/CurrencyBitcoin';
import DeviceHub from './icons/DeviceHub';
import Favorite from './icons/Favorite';
import FileDownload from './icons/FileDownload';
import FilterList from './icons/FilterList';
import FirstPage from './icons/FirstPage';
import GppGood from './icons/GppGood';
import Home from './icons/Home';
import Info from './icons/Info';
import Insights from './icons/Insights';
import LastPage from './icons/LastPage';
import Launch from './icons/Launch';
import LockClock from './icons/LockClock';
import Logout from './icons/Logout';
import ManageSearch from './icons/ManageSearch';
import Menu from './icons/Menu';
import Monitor from './icons/Monitor';
import MoreVert from './icons/MoreVert';
import OpenInNew from './icons/OpenInNew';
import Percent from './icons/Percent';
import Person from './icons/Person';
import PriorityHigh from './icons/PriorityHigh';
import Remove from './icons/Remove';
import RoomService from './icons/RoomService';
import Savings from './icons/Savings';
import Search from './icons/Search';
import Security from './icons/Security';
import Settings from './icons/Settings';
import SettingsEthernet from './icons/SettingsEthernet';
import Shield from './icons/Shield';
import SwapHorizontalCircle from './icons/SwapHorizontalCircle';
import SyncAlt from './icons/SyncAlt';
import TrendingUp from './icons/TrendingUp';
import Troubleshoot from './icons/Troubleshoot';
import Work from './icons/Work';
export const Icons = {
  AccountBalance,
  AccountCircle,
  Add,
  AddIcCall,
  ArrowDownward,
  ArrowDropDown,
  ArrowForward,
  ArrowOutward,
  ArrowUpward,
  Article,
  AutoGraph,
  BarChart,
  CallReceived,
  Cases,
  Check,
  ChevronLeft,
  ChevronRight,
  Circle,
  Close,
  CurrencyBitcoin,
  DeviceHub,
  Favorite,
  FileDownload,
  FilterList,
  FirstPage,
  GppGood,
  Home,
  Info,
  Insights,
  LastPage,
  Launch,
  LockClock,
  Logout,
  ManageSearch,
  Menu,
  Monitor,
  MoreVert,
  OpenInNew,
  Percent,
  Person,
  PriorityHigh,
  Remove,
  RoomService,
  Savings,
  Search,
  Security,
  Settings,
  SettingsEthernet,
  Shield,
  SwapHorizontalCircle,
  SyncAlt,
  TrendingUp,
  Troubleshoot,
  Work,
};
